import CBSARB from "../../assets/CBSARB.png";
import CUOMSA from "../../assets/CUOMSA.jpeg";
import LTSUNN from "../../assets/LTSUNN.jpg";
import EAQAA from "../../assets/EAQAA.png";
import NLA from "../../assets/NLA.png";
import UCA from "../../assets/UCA.png";
import TDA from "../../assets/TDA.png";
import DWED from "../../assets/DWED.png";
import LSS from "../../assets/LSS.png";
import HSS from "../../assets/HSS.png";
import LPS from "../../assets/LPS.png";
import ECMAA from "../../assets/ECMAA.png";
import PDMAA from "../../assets/PDMAA.png";
import LLAMSAAA from "../../assets/IIAMSMAA.png";
import DAA from "../../assets/DAA.png";
import TTCCAAM from "../../assets/TTCCAAM.jpg";
import EMAFFP from "../../assets/EMAFFP.png";
import SMPETAIRAAM from "../../assets/SMPETAIRAAM.png";
import IACSPEEAM from "../../assets/IACSPEEAM.png";
import NBAPCLUNBC from "../../assets/NBAPCLUNBC.png";
import DBCCPEEAM from "../../assets/DBCCPEEAM.png";
import OKKMVQE from "../../assets/OKKMVQE.png";
import CFOMD from "../../assets/CFOMD.png";
import SSAPDPB from "../../assets/SSAPDPB.png";
import HRS from "../../assets/HRS.png";
import CSPADE from "../../assets/CSPADE.png";
import CCSADE from "../../assets/CCSADE.png";
import CFADE from "../../assets/CFADE.png";
import COADE from "../../assets/COADE.png";

export const projectsData = [
  {
    id: 1,
    image: CBSARB,
    title: "Cyclistic Bike-Share: Analyzing <span>Rider Behavior</span>",
    category: ["SQL", "Showcase", "Power BI"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/Cyclistic-Bike-Share--Analyzing-Rider-Behavior",
  },
  {
    id: 2,
    image: SMPETAIRAAM,
    title:
      "Salifort Motors Turnover Prediction: <span>End-to-End Analysis and Modeling</span>",
    category: ["Showcase", "Python", "ML", "Power BI"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/Salifort-Motors-Predicting-Employee-Turnover-and-Improving-Retention-Analysis-and-Modeling",
  },
  {
    id: 3,
    image: CUOMSA,
    title:
      "Retail Store Database Evaluation & <span>Optimization: On-site Internship</span>",
    category: ["SQL", "Showcase"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/CUO-On-Site-Internship--Retail-Store-Database-Evaluation-and-Optimization",
  },
  {
    id: 4,
    image: SSAPDPB,
    title:
      "Superstore Sales & Profit Interactive<span></span>Dashboard in Power BI",
    category: ["Power BI", "Showcase"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/Superstore-Profit-and-Sales-Insights-Dashboard-in-Power-BI",
  },
  {
    id: 5,
    image: CFOMD,
    title:
      "Excel Dashboard Suite: Customer<span></span>Service, Finance & Orders",
    category: ["Excel", "Showcase"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/Excel-Dashboard-Suite-Customer-Service-Finance-and-Orders",
  },
  {
    id: 6,
    image: IACSPEEAM,
    title:
      "Invistico Airlines Customer Satisfac-<span>tion Prediction: Analysis & Modeling</span>",
    category: ["ML", "Python", "Showcase"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/Invistico-Airlines-Customer-Satisfaction-Prediction-End-to-End-Analysis-and-Modeling",
  },
  {
    id: 7,
    image: DBCCPEEAM,
    title:
      "Deutsche Bank Customer Churn: <span></span>End-to-End Analysis and Modeling",
    category: ["ML", "Python", "Showcase"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/Deutsche-Bank-Customer-Churn-Prediction-End-to-End-Analysis-and-Modeling",
  },
  {
    id: 8,
    image: CSPADE,
    title:
      "Customer Service Performance<span></span>Analysis Dashboard in Excel",
    category: ["Excel", "Showcase"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/Customer-Service-Performance-Analysis-Dashboard-in-Excel",
  },
  {
    id: 9,
    image: TTCCAAM,
    title:
      "TikTok Claims Classification: <span>End-to-End Analysis and Modeling</span>",
    category: ["Showcase", "Python", "ML", "Tableau"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/TikTok-Claims-Classification-End-to-End-Analysis-and-Modeling",
  },
  {
    id: 10,
    image: CCSADE,
    title: "CrustBite Customer Service Analysis<span></span>Dashboard in Excel",
    category: ["Excel"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/CrustBite-Customer-Service-Analysis-Dashboard-in-Excel",
  },
  {
    id: 11,
    image: CFADE,
    title: "CrustBite Finance Analysis<span></span>Dashboard in Excel",
    category: ["Excel"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/CrustBite-Finance-Analysis-Dashboard-in-Excel",
  },
   {
    id: 12,
    image: COADE,
    title: "CrustBite Orders Analysis<span></span>Dashboard in Excel",
    category: ["Excel"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/CrustBite-Orders-Analysis-Dashboard-in-Excel/tree/main",
  },
  {
    id: 13,
    image: LLAMSAAA,
    title:
      "Influencer Impact and Marketing <span></span>Sales Modeling and Analysis",
    category: ["ML", "Python"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/Influencer-Impact-and-Marketing-Sales-Modeling-and-Analysis",
  },
  {
    id: 14,
    image: PDMAA,
    title: "Penguins Data Modeling and <span></span>Analysis",
    category: ["ML", "Python"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/Penguins-Data-Analysis-and-Modeling",
  },
  {
    id: 15,
    image: DAA,
    title: "Diamonds ANOVA Analysis",
    category: ["Python", "ML"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/Diamonds-ANOVA-Analysis",
  },
  {
    id: 16,
    image: NBAPCLUNBC,
    title:
      "NBA Career Longevity Prediction <span>with Gaussian Naive Bayes</span>",
    category: ["Python", "ML"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/NBA-Player-Career-Longevity-Prediction-Using-Naive-Bayes-Classifier",
  },
  {
    id: 17,
    image: OKKMVQE,
    title:
      "Optimizing K in K-means: A<span> Visual and Quantitative Exploration</span>",
    category: ["Python", "ML"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/Optimizing-K-in-K-means-A-Visual-and-Quantitative-Exploration",
  },
  {
    id: 18,
    image: NLA,
    title: "NOAA Lightning Analysis",
    category: ["Python"], // Multiple categories here

    demo: "https://github.com/Cyberoctane29/NOAA-Lightning-Analysis",
  },
  {
    id: 19,
    image: UCA,
    title: "Unicorn Companies Analysis",
    category: ["Python"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/Unicorn-Companies-Analysis",
  },
  {
    id: 20,
    image: ECMAA,
    title: "EPA Carbon Monoxide AQI Analysis",
    category: ["Python"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/EPA-Carbon-Monoxide-AQI-Analysis",
  },
  {
    id: 21,
    image: EMAFFP,
    title: "Elderly Motion Analytics for Fall<span></span>Prevention",
    category: ["Python", "ML"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/Elderly-Motion-Analytics-for-Fall-Prevention",
  },
  {
    id: 22,
    image: DWED,
    title: "District Literacy Analysis",
    category: ["Python"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/District-Literacy-Analysis",
  },
  {
    id: 23,
    image: EAQAA,
    title: "EPA Air Quality AQI Analysis",
    category: ["Python"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/EPA-Air-Quality-AQI-Analysis",
  },
  {
    id: 24,
    image: TDA,
    title: "Train Dataset Analysis",
    category: ["Python"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/Train-Dataset-Insights",
  },
  {
    id: 25,
    image: LTSUNN,
    title: "Language Translation System <span></span>Using Neural Networks",
    category: ["ML", "Python"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/Language-Translation-System-Using-Neural-Networks",
  },
  {
    id: 26,
    image: LSS,
    title: "LeetCode SQL Problem Solving",
    category: ["SQL", "Problem Solving"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/LeetCode-SQL-Solutions",
  },
  {
    id: 27,
    image: HSS,
    title: "HackerRank SQL Problem Solving",
    category: ["SQL", "Problem Solving"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/HackerRank-SQL-Solutions",
  },
  {
    id: 28,
    image: LPS,
    title: "LeetCode Python Problem Solving",
    category: ["Python", "Problem Solving"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/LeetCode-Python-Solutions",
  },
  {
    id: 29,
    image: HRS,
    title: "HackerRank Regex Problem Solving",
    category: ["Python", "Problem Solving"], // Multiple categories here
    demo: "https://github.com/Cyberoctane29/HackerRank-Regex-Problem-Solving",
  },
];

// Ensure this is exported as well
export const projectsNav = [
  {
    name: "All",
  },
  {
    name: "Showcase",
  },
  {
    name: "SQL",
  },
  {
    name: "Python",
  },
  {
    name: "Power BI",
  },
  {
    name: "Excel",
  },
  {
    name: "ML",
  },
  {
    name: "Problem Solving",
  },
];
